export default {
  brand: "BasetaoSheet",
  nav: {
    spreadsheet: "Spreadsheet",
    guides: "Guias",
    categories: "Categorias",
    review: "Avaliação",
    shipping: "Envio",
    home: "Início",
    faq: "FAQ",
    shoppingGuide: "Guia de compras",
    visitMain: "Visitar o site principal",
  },
  search: {
    placeholder: "Pesquisar Basetao Spreadsheet, vendedores, envio...",
  },
  cta: {
    basetaoSpreadsheet: "Basetao Spreadsheet",
    buyNow: "Comprar agora",
    visitMain: "Visitar o site principal",
    explore: "Explorar",
  },
  lang: {
    label: "Idioma",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  notFound: {
    title: "Página não encontrada",
    subtitle: "Desculpe, a página que você procura não existe ou pode ter sido movida.",
    backHome: "Voltar ao início",
  },
  categories: {
    title: "Explorar categorias de produtos",
    subtitle: "Descubra cada grupo de produtos coberto pelo spreadsheet, cada um ligado ao catálogo principal.",
    shoes: "Calçados",
    hoodies: "Moletons / Suéteres",
    tshirts: "Camisetas",
    jackets: "Jaquetas",
    pants: "Calças / Shorts",
    headwear: "Chapéus / Bonés",
    sets: "Conjuntos",
    underwear: "Roupas íntimas",
    jersey: "Camisas esportivas",
    accessories: "Acessórios",
    bags: "Bolsas",
    belts: "Cintos",
    perfumes: "Perfumes",
    other: "Outros itens",
    empty: "Nenhuma categoria corresponde à sua pesquisa.",
  },
  footer: {
    tagline: "Um centro de recursos independente para guias, vendedores, envio, cupons e dicas de segurança do Basetao Spreadsheet.",
    resources: "Recursos",
    quickLinks: "Links rápidos",
    disclaimer: "Este site é um recurso informativo independente e não é afiliado à Basetao. Os links de produtos levam ao site principal.",
    copyright: "© 2026 BasetaoSheet. Todos os direitos reservados.",
    privacy: "Privacidade",
    terms: "Termos",
    contact: "Contato",
  },
};